export const POSTS = [
  {
    date: '01 Aug 2021',
    image: 'https://miro.medium.com/max/1400/1*3gwUqtVMJ6JbV-EvERBFnA.jpeg',
    name: 'Interaction with Prime Minister Modi',
    url: 'https://jagannathbhat.medium.com/interaction-with-prime-minister-modi-2eccfd577685?source=bhat_dev',
  },
  {
    date: '24 Jul 2021',
    image: 'https://miro.medium.com/max/1400/1*gBlqqS2nXKNfDfWy4Yiq_g.png',
    name: 'Foodvid — Building a startup during the pandemic',
    url: 'https://jagannathbhat.medium.com/foodvid-building-a-startup-during-the-pandemic-3f96bbbafbd8?source=bhat_dev',
  },
  {
    date: '18 Jul 2021',
    image: 'https://miro.medium.com/max/1400/0*v_wMlIO2y97nBjoR',
    name: 'Registering your Partnership in Kerala — Deed, Lawyer, eGroops, Startup India, KSUM',
    url: 'https://jagannathbhat.medium.com/registering-your-partnership-in-kerala-deed-lawyer-egroops-startup-india-ksum-1d8e65f236e4?source=bhat_dev',
  },
  {
    date: '10 Jul 2021',
    image: 'https://miro.medium.com/max/1400/1*G4LKuWlnFvYvNapjAuu9Kw.jpeg',
    name: 'How to use a Journal to Improve Yourself and Achieve Your Goals',
    url: 'https://jagannathbhat.medium.com/journals-and-mental-health-3b4249efbf46?source=bhat_dev',
  },
  {
    date: '13 May 2020',
    image: 'https://miro.medium.com/max/1400/1*mbeGECfc4gIJSZhufTTvmg.jpeg',
    name: 'Learning Web Design in the Time of Coronavirus: How the Workshop went Online',
    url: 'https://medium.com/tinkerhub/learning-web-design-in-the-time-of-coronavirus-97056c975371?source=bhat_dev',
  },
  {
    date: '12 Sep 2019',
    image: 'https://miro.medium.com/max/1400/0*eCA0cNhJIepw3uqL',
    name: 'Getting Started is Half the Journey: FOSS Lessons from ASIET',
    url: 'https://medium.com/tinkerhub/getting-started-eee4a77c63dd?source=bhat_dev',
  },
]
